import React, { useState, useEffect, memo } from "react";
import { useSharedDataContext } from "../SharedDataContext";
import { isObjEmpty, isBothObjSame } from "../utility/utilityFunction";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
const Covers = ({ onAddonCoverChange, onEmergencyDropdownChange,
    onVetDropdownChange,
    onVetAmountChange,
    selectedSI }) => {

    const { sharedData, setSharedData } = useSharedDataContext();

    const [emergencyDropdown, setEmergencyDropdown] = useState("0");
    // State for VeteneryConsultationOrDoctorOnCallCover dropdown selections
    const [vetDropdown, setVetDropdown] = useState("0");
    const [vetAmount, setVetAmount] = useState("0");
    const [isApplyBtn, setApplyBtn] = useState(false);
    const [IsOpenAddons, setIsOpenAddons] = useState(false);
    const [addonCovers, setAddonCovers] = useState({
        ThirdPartyLiabilityCover: false,
        PersonalBelongingsCover: false,
        EmergencyPetMindingCover: false,
        VeteneryConsultationOrDoctorOnCallCover: false,
        FuneralCostCover: false,
        TerminalDiesease: false,
        LongTermCover: false,
    });
    const [addonCoversNames] = useState({
        ThirdPartyLiabilityCover: "Third Party Liability Cover",
        PersonalBelongingsCover: "Lost & Stolen Cover",
        EmergencyPetMindingCover: "Emergency Pet Minding Cover",
        VeteneryConsultationOrDoctorOnCallCover: "Veterinary Consultation On Call Cover",
        FuneralCostCover: "Funeral Cost Cover",
        TerminalDiesease: "Terminal Disease",
        LongTermCover: "Long Term Cover",
    });

    useEffect(() => {
        //  console.log({ sharedData });
        if (sharedData.AddonsSelected && !isObjEmpty(sharedData.AddonsSelected)) {

            setAddonCovers(sharedData?.AddonsSelected);
        }
    }, [sharedData.AddonsSelected])

    const AddonsToggle = () => {
        setIsOpenAddons(true);
    }
    const handleAddonCoverChange = (addonName) => {
        let cover = { ...addonCovers, [addonName]: !addonCovers[addonName] }
        /*    setAddonCovers((prevCovers) => ({
                ...prevCovers,
                [addonName]: !prevCovers[addonName],
            }));*/
        setAddonCovers(cover);

        setApplyBtn(true);
        if (addonCovers[addonName]) {
            if (addonName === "EmergencyPetMindingCover") {
                setEmergencyDropdown("0");
            } else if (addonName === "VeteneryConsultationOrDoctorOnCallCover") {
                setVetDropdown("0");
                setVetAmount("0");
            }
        } else if (!addonCovers[addonName]) {
            if (addonName === "EmergencyPetMindingCover") {
                setEmergencyDropdown("5");
            } else if (addonName === "VeteneryConsultationOrDoctorOnCallCover") {
                setVetDropdown("5");
                setVetAmount("1000");
            }
        }

    };

    const handleDropdownAmount = (e) => {
        const { name, value } = e.target;
        setApplyBtn(true);
        switch (name) {
            case "emergencyDropdown":
                setEmergencyDropdown(value);
                break;
            case "vetDropdown":
                setVetDropdown(value);
                break;
            case "vetAmount":
                setVetAmount(value);
                break;


        }
    }

    const addonTooltips = {
        ThirdPartyLiabilityCover: 'Third-party liability cover in pet insurance protects against legal costs and damages if your pet causes injury to another person or damages their property',
        PersonalBelongingsCover: 'It’s refers to coverage that helps pet owners in the event if their pet is lost or stolen',
        EmergencyPetMindingCover: 'It provides temporary care for your pet if you are hospitalized or unable to care for them due to an emergency',
        VeteneryConsultationOrDoctorOnCallCover: 'Veterinary Consultation on Call cover provides 24/7 access to veterinary advice and consultations via phone or video call, ensuring immediate professional guidance for pet health concerns',
        FuneralCostCover: "Funeral Cost Cover in pet insurance provides financial assistance for the expenses associated with a pet's burial or cremation",
        TerminalDiesease: 'Terminal Disease coverage in pet insurance covers the diagnosis, treatment, and management of life-ending conditions in pets, providing financial support for palliative and end-of-life care',
        LongTermCover: "Long-term cover in pet insurance provides ongoing coverage for chronic or recurring conditions throughout the pet's life, subject to policy limits",
    };

    useEffect(() => {


        setEmergencyDropdown(sharedData?.EmergencyPetMindingCoverDays);
        setVetDropdown(sharedData?.VeteneryConsultationOrDoctorOnCallCoverDays);
        setVetAmount(sharedData?.VeteneryConsultationOrDoctorOnCallCoverAmount)

    }, []);

    useEffect(() => {
        const { AddonsSelected } = sharedData;
        if (sharedData.AddonsSelected && !isBothObjSame(addonCovers, AddonsSelected)) {
            setApplyBtn(true);
        } else {
            setApplyBtn(false);
        }
    }, [sharedData.AddonsSelected, addonCovers]);



    const renderTooltip = (coverName) => (
        <Tooltip id={`tooltip-${coverName}`} className="custom-tooltip">
            {coverName}
        </Tooltip>
    );

    const applyAddons = () => {
        onAddonCoverChange(addonCovers);
        setSharedData(prev => ({ ...prev, AddonsSelected: addonCovers }));
        if (addonCovers.EmergencyPetMindingCover) {
            onEmergencyDropdownChange(emergencyDropdown);
            setSharedData(prev => ({ ...prev, EmergencyPetMindingCoverDays: emergencyDropdown }));
        }
        if (addonCovers.VeteneryConsultationOrDoctorOnCallCover) {
            setSharedData(prev => ({ ...prev, VeteneryConsultationOrDoctorOnCallCoverDays: vetDropdown }));
            setSharedData(prev => ({ ...prev, VeteneryConsultationOrDoctorOnCallCoverAmount: vetAmount }));
            onVetDropdownChange(vetDropdown);
            onVetAmountChange(vetAmount);
        }
        setApplyBtn(false);
        setIsOpenAddons(false);
    }



    const selectedAddonsLength = Object.values(addonCovers)?.filter(r => r == true).length;

    return (
        <div className="MainFeaturesinMOb">
            <div className="AddonsAndAccList">
                <div className="AddonsHeading d-flex justify-content-between p-2 align-items-center">
                    <h3 onClick={AddonsToggle}>{selectedAddonsLength > 0 ? `${selectedAddonsLength} Selected ${selectedAddonsLength == 1 ? "Addon" : "Addons"}` : "Additional Addons"}</h3>
                    <div className="QuestionPopupPage">
                        {isApplyBtn && <button className="addonApplyBtn" onClick={applyAddons}>Apply Now</button>}
                    </div>
                </div>
                <div className={IsOpenAddons ? "AddonsMobList AddonsMobListInside " : "AddonsMobList"}>
                    <div className="AddonsList">
                        <div class="MbileVeiwPop">
                            <p>Addons List</p>
                            <button type="button" class="close btn-success" onClick={() => { setIsOpenAddons(false); setAddonCovers(sharedData.AddonsSelected) }}><img src={require("../../assets/images/Cross.svg").default} alt="Cross Icon" /></button>
                            {isApplyBtn && <button onClick={applyAddons} class="SMCSmall pt-1 pb-1 h-auto">Apply Now</button>}
                        </div>
                        {Object.keys(addonCovers)?.map((coverName) => (
                            <div className="CheckBoxColor" key={coverName}>
                                <div className="QuestionPopupPage QuestionPopupAddons">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={renderTooltip(addonTooltips[coverName])}
                                    >

                                        <label className="custom-checkbox">
                                            <input
                                                id={coverName}
                                                name={`addon-${coverName}`}
                                                type="checkbox"
                                                checked={addonCovers[coverName]}
                                                onChange={() => handleAddonCoverChange(coverName)}
                                            />
                                            <span class="checkmark"></span>
                                            <div className={` ${(coverName === "EmergencyPetMindingCover" && addonCovers[coverName] || coverName === "VeteneryConsultationOrDoctorOnCallCover" && addonCovers[coverName])} OnCheck`}>
                                                <span
                                                    data-tip="Tooltip text here"
                                                    data-for={`tooltip-${coverName}`}
                                                >
                                                    {addonCoversNames[coverName]}
                                                </span>


                                                <button type="button" className="clsBtn">
                                                    {/*<img src={require("../../assets/images/Cross.svg").default} alt="" />*/}
                                                    <span><i class="fa fa-times" aria-hidden="true" onClick={() => handleAddonCoverChange(coverName)}></i></span>
                                                </button>
                                            </div>
                                        </label>
                                    </OverlayTrigger>

                                    {coverName === "EmergencyPetMindingCover" && addonCovers[coverName] && (
                                        <div className="SubDDPet">
                                            <label>Select days:</label>
                                            <div>
                                                <select class="ddlAddonsSelect removeBottomBorder" value={emergencyDropdown} name="emergencyDropdown" onChange={handleDropdownAmount}>
                                                    <option value="5">5 days</option>
                                                    <option value="10">10 days</option>
                                                </select>
                                                {emergencyDropdown === "0" && <p className="error-msg">This field is required.</p>}
                                            </div>
                                        </div>
                                    )}
                                    {coverName === "VeteneryConsultationOrDoctorOnCallCover" && addonCovers[coverName] && (
                                        <>
                                            <div className="SubDDPet">
                                                <label>Select days:</label>
                                                <div>
                                                    <select class="ddlAddonsSelect removeBottomBorder" value={vetDropdown} name="vetDropdown" onChange={handleDropdownAmount}>
                                                        <option value="5">5 days</option>
                                                        <option value="10">10 days</option>
                                                    </select>
                                                    {vetDropdown === "0" && <p className="error-msg">This field is required.</p>}
                                                </div>
                                            </div>
                                            <div className="SubDDPet">
                                                <label>Select amount:</label>
                                                <div>
                                                    <select class="ddlAddonsSelect removeBottomBorder" value={vetAmount} name="vetAmount" onChange={handleDropdownAmount}>
                                                        <option value="1000">₹1000</option>
                                                        <option value="2000">₹2000</option>
                                                    </select>
                                                    {vetAmount === "0" && <p className="error-msg">This field is required.</p>}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(Covers);